import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { NumericFormatProps, SourceInfo } from 'react-number-format';
import useMoney from '../../hooks/useMoney';
import { useTranslation } from '../../modules/translation/TranslationContext';
import teceoInputConfig from '../../utils/TeceoInputConfig';
import NumberFormatCustom, { NumberFormatCustomOnChange } from '../NumberFormatCustom';

const MoneyFormat: React.FC<
  NumericFormatProps & {
    onChange: (params: NumberFormatCustomOnChange, event: SourceInfo['event']) => void;
  }
> = React.forwardRef(({ getInputRef, onChange, ...rest }, ref) => {
  const { decimalSeparator, thousandSeparator } = useMoney();

  return (
    <NumberFormatCustom
      getInputRef={getInputRef}
      onChange={onChange}
      ref={ref}
      {...rest}
      decimalScale={2}
      fixedDecimalScale
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
    />
  );
});

const MoneyTextField: React.FC<any> = React.forwardRef(
  ({ input, meta, InputProps, slotProps, allowNegative = false, ...props }, ref) => {
    const { getCurrencySymbol, formatMoney } = useMoney();
    const { translate } = useTranslation();

    return (
      <TextField
        {...teceoInputConfig}
        {...props}
        {...input}
        error={(meta?.touched && !!meta?.error) || props?.error}
        helperText={
          props.helperText ||
          (meta?.touched && !!meta?.error && translate(meta?.error, {}, meta?.error))
        }
        placeholder={formatMoney(0, { style: 'decimal' })}
        variant={props.variant}
        slotProps={{
          ...slotProps,
          inputLabel: {
            shrink: input?.value !== '' || undefined,
            ...slotProps?.inputLabel,
          },
          input: {
            ...InputProps,
            ...slotProps?.input,
            startAdornment: <InputAdornment position="start">{getCurrencySymbol()}</InputAdornment>,
            inputComponent: MoneyFormat,
            inputRef: ref,
          },
          htmlInput: {
            ...slotProps?.htmlInput,
            ...(props.inputProps as object),
            allowNegative,
          },
        }}
      />
    );
  },
);

export default React.memo(MoneyTextField);
